<ldw-pdf-viewer [document]="document"
                [downloadAllowed]="true"
                [printAllowed]="true"></ldw-pdf-viewer>
